var map = {
	"./Loading-Icon.gif": 18827,
	"./app-awareness-phone.png": 21490,
	"./app-modal-android@2x.png": 16853,
	"./app-modal-iphone@2x.png": 75169,
	"./app-promo-banner-background.png": 99507,
	"./box-prices/2-portions.png": 14494,
	"./box-prices/2-portions.webp": 42503,
	"./box-prices/4-portions.png": 39576,
	"./box-prices/4-portions.webp": 14245,
	"./box-prices/box-prices-hero.jpg": 4026,
	"./box-prices/couples-box.jpg": 30558,
	"./box-prices/family-box.jpg": 30137,
	"./box-prices/four-person-box.jpg": 27787,
	"./box-prices/two-person-box.jpg": 37093,
	"./discount-modal-header.jpg": 61433,
	"./discount-softening-experiment-modal-image.jpg": 831,
	"./earn-reward-background.jpg": 6069,
	"./five-recipes/five-recipes.png": 55851,
	"./food/cauli-mac-cheese.jpg": 69740,
	"./food/jamaican-squash-coconut-stew.jpg": 72812,
	"./food/sweet-potato-dal.jpg": 19684,
	"./food/sweet-potato-sag-aloo.jpg": 75062,
	"./gousto-box.jpg": 39906,
	"./gousto-boxes.jpg": 74175,
	"./gousto-welcome-journey-rollover.jpg": 43977,
	"./hungry-for-savings.png": 90781,
	"./icon-gbox.svg": 10654,
	"./icon-van.svg": 79487,
	"./menu/FebYouary_desktop.jpg": 66773,
	"./menu/FebYouary_mobile.jpg": 5559,
	"./menu/FebYouary_tablet.jpg": 58761,
	"./menu/default_desktop_no_click.png": 36701,
	"./menu/default_mobile_no_click.png": 92473,
	"./menu/default_tablet_no_click.png": 70199,
	"./menu/spottyTileBorder.png": 49235,
	"./my-gousto-pricing-modal.svg": 95672,
	"./pause-osr-modal-bg.jpg": 37129,
	"./product-placeholder.png": 93609,
	"./recipe-placeholder.png": 77224,
	"./red-rice-pattern.png": 23690,
	"./spinner.gif": 2564,
	"./zest-logo.svg": 6942
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 59174;